export default __webpack_public_path__ + "static/media/There-are-no-messages.489a0fdd.svg";